module.exports = __webpack_public_path__ + "assets/img/btn-view-e2f0f607.png";